import styled from 'styled-components';
import { ReactComponent as SettingIcon } from './settings.svg';
import { ICON_CSS_CONFIG } from '../../../Utilities/cssConfig';

const SettingIconStyled = styled(SettingIcon)`
    height: 24px;
    fill: ${({ selected }) => (selected ? ICON_CSS_CONFIG.selected : ICON_CSS_CONFIG.normal)};
`;

export default SettingIconStyled;
